// extracted by mini-css-extract-plugin
export default {"item":"sEbqp2QRdBc5HrfP9WUL","option":"nyfPAXxm7fAbTcDONCm3","question":"bGZAsyMBnAxCCWRGKusG","remove":"MYff0fMStz8Fyf4dLQt6"};